import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { streamActions, streamSelectors } from '../../../store/modules/stream';

const useFetchRoomSettings = (roomId?: string) => {
  const dispatch = useDispatch();
  const roomSettings = useSelector(streamSelectors.selectRoomSettings);

  useEffect(() => {
    roomId && dispatch(streamActions.getRoomSettings(roomId));
  }, [roomId]);

  useEffect(
    () => () => {
      dispatch(streamActions.clearRoomSettings());
    },
    []
  );

  return roomSettings;
};

export default useFetchRoomSettings;
